import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Routes } from "@ctypes";
import { useInitiateLoginWithPhone } from "@hooks";
import { getQueryParams, isValidPhoneNumber, sanitizePhoneNumber } from "@utils";

// Deep-link entry point (e.g. from an SMS/email). With a valid `phoneNumber`
// query param it requests the OTP immediately and drops the user straight
// into the code screen; otherwise it just routes into the phone login page.
export const PhoneAuthCallbackRoute = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [initiateLoginWithPhone] = useInitiateLoginWithPhone();

  useEffect(() => {
    (async () => {
      const params = getQueryParams(location.search);
      const rawPhoneNumber = Array.isArray(params.phoneNumber)
        ? params.phoneNumber[0]
        : params.phoneNumber;
      const phoneNumber = rawPhoneNumber ? sanitizePhoneNumber(rawPhoneNumber) : undefined;

      if (phoneNumber && isValidPhoneNumber(phoneNumber)) {
        try {
          await initiateLoginWithPhone({ variables: { phoneNumber } });

          navigate(Routes.Auth, {
            replace: true,
            state: { initialStep: Routes.PhoneLoginVerification, phoneNumber },
          });
          return;
        } catch {
          // Fall through to manual phone entry below so the user can retry.
        }
      }

      navigate(Routes.Auth, { replace: true, state: { initialStep: Routes.PhoneLoginInput } });
    })();
  }, []);

  return null;
};
